export const INITIAL_FORM = {
  nombre: "",
  apellido: "",
  email: "",
  phone: "",
  horario: "",
};

export const INITIAL_TOUCHED = {
  nombre: false,
  apellido: false,
  email: false,
  phone: false,
  horario: false,
};

export const INITIAL_ERRORS = {
  nombre: "",
  apellido: "",
  email: "",
  phone: "",
  horario: "",
};

const NAME_PATTERN = /^[A-Za-zÁÉÍÓÚáéíóúÑñ ]+$/;
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateField = (field, value) => {
  if (value === undefined || value === null) value = "";

  switch (field) {
    case "nombre":
    case "apellido":
      if (!value.trim() || !NAME_PATTERN.test(value.trim())) {
        return "Por favor, revisá este campo nuevamente.";
      }
      return "";
    case "email":
      if (!value.trim() || !EMAIL_PATTERN.test(value.trim())) {
        return "Ingresá un e-mail válido.";
      }
      return "";
    case "phone": {
      const phonePattern = /^\d{10}$/;
      if (!phonePattern.test(value)) {
        return "Solo números, sin 0 y sin 15 (10 díg.)";
      }
      return "";
    }
    case "horario":
      if (!value) {
        return "Seleccioná un horario.";
      }
      return "";
    default:
      return "";
  }
};

export const isFormValid = (contact, errors) => {
  const fields = ["nombre", "apellido", "email", "phone", "horario"];
  return fields.every((field) => contact[field] && errors[field] === "");
};

export const getInputClass = (field, value, { errors, touched, focus }) => {
  if (errors[field] && touched[field]) return "error";
  if (!errors[field] && value) return "success";
  if (focus[field]) return "focused";
  return "";
};
